import 'angular';

export function CustomerSelectionForAccountingCtrl (
  $scope,
  $translate,
  inheritorApi,
  messages,
  ukPostcodeApi,
  workshopAPI
) {
  $scope.addressSearch = {
    list: [],
    selected: {
      id: '',
      full_address: ''
    },
    search (typed) {
      return workshopAPI.get('/NzPostal/get_addresses', typed).then(addresses => {
        return addresses && addresses !== 'null' ? addresses : '';
      });
    },
    choose (address) {
      return workshopAPI.get('/NzPostal/get_address_details', address.address_id).then(details => {
        $scope.customer.address1     = details['address1'];
        $scope.customer.address2     = details['address2'];
        $scope.customer.country_code = details['country_code'];
        $scope.customer.latitude     = details['latitude'];
        $scope.customer.longitude    = details['longitude'];
        $scope.customer.postcode     = details['postcode'];
        $scope.customer.state        = details['state'];
        $scope.customer.suburb       = details['suburb'];
      })
    },
    format (address) {
      return angular.isString($scope.customer.address1) ? $scope.customer.address1 : ''
    }
  };

  inheritorApi.inheritCtrl('CustomerSelectionForAccountingLiteCtrl', $scope);

  $scope.searchUKPostcode = function () {
    ukPostcodeApi.search($scope.customer.postcode)
    .then(data => {
      $scope.customer.address1 = data.Premises;
      $scope.customer.address2 = data.Street;
      $scope.customer.postcode = data.Postcode;
      $scope.customer.suburb   = data.PostTown;

      messages.show($translate.instant('CUSTOMER_SPACE.CUSTOMER_ADDRESS_UPDATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };
}